import axios from "axios";
import { connect } from "twilio-video";

export const getIdentity = (name: string, isHost = false) => {
  const identifiableToken = {
    isHost: isHost,
    name: name,
    browserName: getBrowserName(),
    timestamp: Math.floor(Date.now() / 1000)
  };
  return JSON.stringify(identifiableToken);
};

export const getBrowserName = () => {
  const userAgent = navigator.userAgent;
  let browserName: string;

  if (userAgent.includes("Firefox")) {
    browserName = "Mozilla Firefox";
  } else if (userAgent.includes("Edg")) {
    browserName = "Microsoft Edge";
  } else if (userAgent.includes("Chrome") && !userAgent.includes("Edg")) {
    browserName = "Google Chrome";
  } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
    browserName = "Apple Safari";
  } else if (userAgent.includes("Opera") || userAgent.includes("OPR")) {
    browserName = "Opera";
  } else if (userAgent.includes("Trident")) {
    browserName = "Internet Explorer";
  } else {
    browserName = "Unknown Browser";
  }
  return browserName;
};

export const getAuthToken = async (identity: string, roomId: string) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_SS_BASE_URL}/generate-token?identity=${identity}&roomId=${roomId}`);
    const { videoToken } = await response.json();
    if (videoToken) {
      return videoToken;
    } else {
      console.log("object");
      throw new Error();
    }
  } catch (err) {
    throw new Error("Error in getting auth token");
  }
};

export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    console.error("Error copying text to clipboard:", error);
    return false;
  }
};

export const getParams = (url: string) => {
  const match = url.match(/join\/([a-zA-Z0-9-]+)/);
  const tokenMatch = url.match(/token\/([a-zA-Z0-9-]+)/);
  const textAfterJoin = match ? match[1] : null;
  const textAfterToken = tokenMatch ? tokenMatch[1] : null;

  return { roomId: textAfterJoin, authToken: textAfterToken };
};

export const createRoom = async (roomId: string) => {
  try {
    const room = await axios(`${process.env.REACT_APP_SS_BASE_URL}/create-room/${roomId}`);
    if (!room) {
      throw new Error("Room not found");
    }
  } catch (err) {
    if (err instanceof TypeError) {
      throw new Error("Network issue: Please check your connection.");
    }
    throw new Error("Unable to get the screen track.");
  }
};

export const connectHostToRoom = async (authToken: string, roomId: string) => {
  try {
    const localRoom = await connect(authToken, {
      name: roomId,
      video: false,
      audio: false
    });
    sessionStorage.setItem("ROOMNAME", localRoom.name);
    return localRoom;
  } catch (err) {
    console.log("Error in connecting with room", err);
    throw new Error("Error in connecting with room");
  }
};

export function getUTCTimeFormatted() {
  const now = new Date();

  // Extract UTC components
  const day = String(now.getUTCDate()).padStart(2, "0");
  const month = String(now.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-based
  const year = now.getUTCFullYear();

  let hours = now.getUTCHours();
  const minutes = String(now.getUTCMinutes()).padStart(2, "0");

  const amPm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // Convert to 12-hour format

  return `${month}/${day}/${year} ${hours}:${minutes} ${amPm}`;
}

export const getFormattedDate = () => {
  const date = new Date();

  // Get day, month, and year
  const day = String(date.getDate()).padStart(2, "0"); // Ensure 2 digits
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const year = date.getFullYear();

  // Get hours, minutes, and AM/PM
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0"); // Ensure 2 digits
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // Convert to 12-hour format

  // Format the date and time
  const formattedDate = `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
  return formattedDate;
};

export const fetchIPAddress = async () => {
  try {
    // Using ipify API to get the IP address
    const response = await axios.get("https://api.ipify.org?format=json");
    return response.data.ip;
  } catch (error) {
    console.error("Error fetching IP address:", error);
  }
};
